import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Box, Card, List, ListItem, ListItemIcon, CircularProgress, CardContent } from '@mui/material';
import VideocamIcon from '@mui/icons-material/Videocam';
import { AuthenticationContext } from '../../components/AuthenticationContext';
import Login from '../Login';
import { GQL_GET_CAMERAS } from '../../graphql/queries/cameras';
import { useQuery } from '@apollo/client';
import styles from './index.module.css';

const cameraSort = (a: any, b: any) => {
  const va = `${a?.client?.name?.toLowerCase()} - ${a?.name?.toLowerCase()}`;
  const vb = `${b?.client?.name?.toLowerCase()} - ${b?.name?.toLowerCase()}`;
  if (va == vb) return 0;
  return va > vb ? 1 : -1;
};

export default function CameraList() {
  const history = useHistory();
  const { authorized, removeToken } = useContext(AuthenticationContext);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [clientName, setClientName] = useState();
  const [cameras, setCameras] = useState<Array<any>>([]);
  useQuery(GQL_GET_CAMERAS, {
    onError(error) {
      if (error.graphQLErrors.findIndex((err) => err?.extensions?.code == 'UNAUTHENTICATED') != -1) {
        removeToken();
      } else {
        setError(error.message);
        console.error(error);
      }
      setLoading(false);
    },
    onCompleted(data) {
      console.log('complete');
      setCameras([...data?.cameras].sort(cameraSort));
      setClientName(data.client.name);
      setLoading(false);
    },
    skip: !authorized,
  });
  console.log(`render authorized ${authorized} loading ${loading}`);
  if (!authorized) return <Login />;

  const handleClick = (id: string) => {
    history.push(`/camera/${id}`);
  };

  return (
    <Card>
      <CardContent className={styles.card}>
        <h4>
          <span>{clientName || ''}</span>
        </h4>
        <h1 style={{ margin: '0 0 10px' }}>Cameras</h1>
        {error && <h3>{error}</h3>}
        {loading && (
          <Box display="flex" minHeight="300px" justifyContent="center" alignItems="center">
            <CircularProgress />
          </Box>
        )}

        <List>
          {cameras.map((camera: any) => {
            return (
              <ListItem key={camera.id} onClick={() => handleClick(camera.id)} style={{ cursor: 'pointer' }}>
                <ListItemIcon>
                  <VideocamIcon />
                </ListItemIcon>
                {camera?.client?.name} - {camera.name}
              </ListItem>
            );
          })}
        </List>
      </CardContent>
    </Card>
  );
}
